/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
// material
import {
    Button,
    Grid,
    GridSet,
    GridItem,
    Control,
    LoadState,
    SubPage,
    Copy,
    Title,
    SingleSelectDropDown,
    Content,
    PopupMessage } from '@insticator/insticator-ui'; // iui-material
// pages
import Code from 'pages/dashboard/ratings/ratingsmanager/code/code';
import Configuration from 'pages/dashboard/ratings/ratingsmanager/configuration/configuration';
import AddOns from 'pages/dashboard/ratings/ratingsmanager/addons/addons';
import Analytics from 'pages/dashboard/ratings/ratingsmanager/analytics/analytics';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/ratings/ratingsmanager/ratingsmanager_styles';



/* ========== ~~~~~~~~~~ RATING MANAGER ~~~~~~~~~~ ========== */
class RatingsManager extends Component {
    constructor(props){
        super(props);
        this.state = {
            selectedTab: 'code',
            selectedSite: null
        };
        this.iframeEl = null;
    }

    componentDidMount() {
        // set first site as selected
        if(Object.keys(this.props.sites).length) {
            const siteUUID = this.props.mockupGenerator ? this.props.siteUUID : Object.keys(this.props.sites)[0];
            const siteName = this.props.sites[siteUUID];
            const site = { value: siteUUID, name: siteName };
            this.props.selectRatingSite(site);
            this.props.getRatingsConfig(this.props.accountUUID, siteUUID, siteName, this.getRatingsUnitCode);
        }
        this.props.moveToPage(`dashboard/ratings/ratingsmanager/${this.state.selectedTab}`)
    }

    componentDidUpdate(prevProps) {
        if(Object.keys(this.props.sites).length !== Object.keys(prevProps.sites).length){
            const site = {value: Object.keys(this.props.sites)[0], name: this.props.sites[Object.keys(this.props.sites)[0]]}
            this.props.selectRatingSite(site);
            this.props.getRatingsConfig(this.props.accountUUID, site.value, site.name, this.getRatingsUnitCode);
        }
    };

    handleSiteInDropDown = () => {
        let sites = [];
        Object.keys(this.props.sites).forEach( (item) => {
            sites.push({value: item, name: this.props.sites[item]})
        });
        return sites
    };

    selectSite = site => {
        this.props.selectRatingSite(site);
        this.props.getRatingsConfig(this.props.accountUUID, site.value, site.name, this.getRatingsUnitCode);
    }

    handleTabSelect = selectedTab => {
        this.setState({ selectedTab }, this.props.moveToPage(`dashboard/ratings/ratingsmanager/${selectedTab}`));
    }

    getRatingsUnitCode = () => {
        this.props.getRatingsUnitCode(this.props.selectedSite.value);
    }

    /*previewTestPage = () => {
        this.props.displayModal(true, <PopupMessage
            type={'preview'}
            title={'Would you like to navigate to the ratings test page?'}
            body={<p><br/></p>}
            buttonPrimary={{ text: 'Preview', variant: 'primary', action: () => window.open(`${url.rating.ratingUnits}/${this.props.ratingUnitUUID}/test-page`)  && this.props.displayModal(false)}}
            buttonSecondary={{ text: 'Cancel', variant: 'system', action: () => this.props.displayModal(false) }}
        />);
    }*/

    render(){
        return (
            <Content>
                <SubPage name={`ratingsmanager`} klass={this.props.classes.ratingsmanager}>
                    <Copy name={`page-copy`}>
                        <Title variant={`withtip`}>
                            <h2>Ratings {this.props.selectedSite ? `(${this.props.selectedSite.name})` : null}</h2>
                            {/*<Tip space={`left`} content={<p>An ads.txt file is a simple text file (not an Embed code) that is uploaded into your domain’s root directory. In other words, it is implemented the same way a robots.txt file on your root domain would be implemented.</p>}/>*/}
                        </Title>
                    </Copy>
                    <Grid>
                        <GridSet direction={`horizontal`} name={`ratingscontrols`}>
                            <GridItem direction={`horizontal`} name={`controls`}>
                                <Control selected={this.state.selectedTab === 'code'} text={`Code`} value={`code`} handleSelect={this.handleTabSelect} />
                                <Control selected={this.state.selectedTab === 'configuration'} text={`Configuration`} value={`configuration`} handleSelect={this.handleTabSelect} />
                                <Control selected={this.state.selectedTab === 'addons'} text={`Add-ons`} value={`addons`} handleSelect={this.handleTabSelect} />
                                <Control selected={this.state.selectedTab === 'analytics'} text={`Analytics`} value={`analytics`} handleSelect={this.handleTabSelect} />
                                {this.props.mocked && <Button variant={'secondary'} text={'Test Page'} action={`${url.rating.ratingUnits}/${this.props.ratingUnitUUID}/test-page`} type={'external'} />}
                            </GridItem>
                            <GridItem name={'sites'}>
                                <span className={'fieldlabel'}>Website: </span>
                                <SingleSelectDropDown onSelect={this.selectSite} disabled={false} selected={this.props.selectedSite} name={`all sites`} items={this.handleSiteInDropDown()}/>
                            </GridItem>
                        </GridSet>
                    </Grid>
                    {(this.props.fetchingRatingsConfig || !this.props.selectedSite || this.props.fetchingRatingsUnitCode) ? <LoadState/> :
                        (<Switch>
                            <Route exact path='/dashboard/ratings/ratingsmanager/configuration' component={Configuration} />
                            <Route exact path='/dashboard/ratings/ratingsmanager/addons' component={AddOns} />
                            <Route exact path='/dashboard/ratings/ratingsmanager/analytics' component={Analytics} />
                            <Route path='/dashboard/ratings/ratingsmanager' component={Code} />
                        </Switch>)
                    }
                </SubPage>
            </Content>
        );
    }

};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(RatingsManager);
